const ColorSegmentBounds = ({ colorSegmentsBounds, setColorSegmentsBounds }) => {

    const handleChangeColorSegmentBounds = (index) => (e) => {
        setColorSegmentsBounds([index === 0 ? e.target.value : colorSegmentsBounds[0],
            index === 1 ? e.target.value : colorSegmentsBounds[1]]);
    }

    return (
            <>
                <h3>자료범위</h3>
                <div className="w1 cl">
                    <input type="text" value={colorSegmentsBounds[0]} onChange={handleChangeColorSegmentBounds(0)}/>
                    <span className="e1">~</span>
                    <input type="text" value={colorSegmentsBounds[1]} onChange={handleChangeColorSegmentBounds(1)}/>
                </div>
                {/*<input className="input is-small" type="text" style={{height: '2em', width: '60px'}}*/}
                {/*       value={colorSegmentsBounds[0]}*/}
                {/*       onChange={handleChangeColorSegmentBounds(0)}></input>*/}
                {/*&nbsp; - &nbsp;*/}
                {/*<input className="input is-small" type="text" style={{height: '2em', width: '60px'}}*/}
                {/*       value={colorSegmentsBounds[1]}*/}
                {/*       onChange={handleChangeColorSegmentBounds(1)}></input>*/}
            </>
    )
}

export default ColorSegmentBounds;